module.exports = __webpack_public_path__ + "breakfast_at_tiffanys.8f550ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/breakfast_at_tiffanys.jpg
// module id = EUD2
// module chunks = 0